export enum CanHistoryMessages {
  title = "reports.canHistory.title",
  dateTime = "reports.canHistory.dateTime",
  fleet = "reports.canHistory.fleet",
  plate = "reports.canHistory.plate",
  travelDoc = "reports.canHistory.travelDoc",
  status = "reports.canHistory.status",
  driver = "reports.canHistory.driver",
  ignition = "reports.canHistory.ignition",
  ignitionOn = "reports.canHistory.ignitionOn",
  ignitionOff = "reports.canHistory.ignitionOff",
  odometer = "reports.canHistory.odometer",
  totalFuel = "reports.canHistory.totalFuel",
  speed = "reports.canHistory.speed",
  rpm = "reports.canHistory.rpm",
  coolantTemp = "reports.canHistory.coolantTemp",
  fuelConsumption = "reports.canHistory.fuelConsumption",
  fuelLevel = "reports.canHistory.fuelLevel",
  hourmeter = "reports.canHistory.hourmeter",
  totalDrivingTime = "reports.canHistory.totalDrivingTime",
  idleFuel = "reports.canHistory.idleFuel",
  address = "reports.canHistory.address",
  rawDataTooltip = "reports.canHistory.rawDataTooltip",
}

export type TranslationCanHistoryMessages = {
  [CanHistoryMessages.title]: string,
  [CanHistoryMessages.dateTime]: string,
  [CanHistoryMessages.fleet]: string,
  [CanHistoryMessages.plate]: string,
  [CanHistoryMessages.travelDoc]: string,
  [CanHistoryMessages.status]: string,
  [CanHistoryMessages.driver]: string,
  [CanHistoryMessages.ignition]: string,
  [CanHistoryMessages.ignitionOn]: string,
  [CanHistoryMessages.ignitionOff]: string,
  [CanHistoryMessages.odometer]: string,
  [CanHistoryMessages.totalFuel]: string,
  [CanHistoryMessages.speed]: string,
  [CanHistoryMessages.rpm]: string,
  [CanHistoryMessages.coolantTemp]: string,
  [CanHistoryMessages.fuelConsumption]: string,
  [CanHistoryMessages.fuelLevel]: string,
  [CanHistoryMessages.hourmeter]: string,
  [CanHistoryMessages.totalDrivingTime]: string,
  [CanHistoryMessages.idleFuel]: string,
  [CanHistoryMessages.address]: string,
  [CanHistoryMessages.rawDataTooltip]: string,
};
